'use client';

import { useRef } from 'react';
import type { MutableRefObject } from 'react';

/**
 * The propose of this hooks is create a ref element with a callback to prevent depend on non memoized functions
 * @param callback some function to memoized in a ref element
 * @returns ref element with the callback
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export const useInvariantCallbackRef = <T extends Function>(
  callback?: T
): MutableRefObject<T> => {
  // Guard for undefined callbacks
  const emptyCallback: unknown = (): void => void 0;
  const invariantCallback: T =
    typeof callback === 'function' ? callback : (emptyCallback as T);

  const callbackRef = useRef(invariantCallback);
  callbackRef.current = invariantCallback;
  return callbackRef;
};
